import { render } from "./StockTradingModal.vue?vue&type=template&id=e08c8134&scoped=true"
import script from "./StockTradingModal.vue?vue&type=script&lang=js"
export * from "./StockTradingModal.vue?vue&type=script&lang=js"

import "./StockTradingModal.vue?vue&type=style&index=0&id=e08c8134&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e08c8134"]])

export default __exports__